export const rgbPattern =
  /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/g
export const hslPattern =
  /(?:hsl\()?\s*([\d°]+%?)\s*,\s*(\d+\.?\d*%?)\s*,\s*(\d+\.?\d*%?)\s*(?:\))?/g
export const hexPattern =
  /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/g
export const parenthesesPattern = /\(([^)]+)\)/g

function componentToHex(c: number) {
  const hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

export const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

export const hexToRgb = (hex: string): [number, number, number] | null => {
  // Remove the hash if it exists
  hex = hex.replace(/^#/, '')

  let r, g, b

  if (hex.length === 3) {
    // Handle shorthand hex (#RGB)
    r = parseInt((hex[0] as string) + hex[0], 16)
    g = parseInt((hex[1] as string) + hex[1], 16)
    b = parseInt((hex[2] as string) + hex[2], 16)
  } else if (hex.length >= 6) {
    // Handle full hex (#RRGGBB), ignore any additional characters
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
  } else {
    // Invalid hex color
    return null
  }

  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return null
  }

  return [r, g, b]
}

export const rgbToHsl = (r: number, g: number, b: number) => {
  r /= 255
  g /= 255
  b /= 255
  const l = Math.max(r, g, b)
  const s = l - Math.min(r, g, b)
  const h = s
    ? l === r
      ? (g - b) / s
      : l === g
      ? 2 + (b - r) / s
      : 4 + (r - g) / s
    : 0

  const H = Math.round(60 * h < 0 ? 60 * h + 360 : 60 * h)
  const S = Math.round(
    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0)
  )
  const L = Math.round((100 * (2 * l - s)) / 2)

  return [H, S, L]
}

export const parseColorValue = (value: string) => {
  const hexMatches = value.match(hexPattern)
  if (hexMatches?.length) {
    return [hexMatches].toString()
  }

  const rgbMatches = value.match(rgbPattern)
  if (rgbMatches?.length) {
    const rgbWithoutPrentheses = [rgbMatches]
      .toString()
      .match(parenthesesPattern)
      ?.map((match) => match.slice(1, -1))

    if (rgbWithoutPrentheses?.length) {
      const rgb = rgbWithoutPrentheses
        .toString()
        .split(',')
        .map((v) => parseInt(v))

      if (rgb.length === 3) {
        return rgbToHex(...(rgb as [number, number, number]))
      }
    }
  }

  // TODO: Match hsl
  // const hslMatches = value.match(rgbPattern)
  // if (rgbMatches?.length) {
  //   const rgbWithoutPrentheses = [rgbMatches]
  //     .toString()
  //     .match(parenthesesPattern)
  //     ?.map((match) => match.slice(1, -1))

  //   if (rgbWithoutPrentheses?.length) {
  //     const rgb = rgbWithoutPrentheses
  //       .toString()
  //       .split(',')
  //       .map((v) => parseInt(v))

  //     if (rgb.length === 3) setVal(rgbToHex(...rgb))
  //   }
  // }
}
